import React from 'react';
import { copyTextToClipboard } from '../utils/clipboard';
import { Button } from './Button';

export function CopyButton({ value, children = 'Copy', copiedLabel = 'Copied', ...props }) {
  const [copied, setCopied] = React.useState(false);
  const resetTimerRef = React.useRef(null);

  React.useEffect(() => () => {
    if (resetTimerRef.current) window.clearTimeout(resetTimerRef.current);
  }, []);

  async function handleCopy() {
    const didCopy = await copyTextToClipboard(value);
    if (!didCopy) return;
    setCopied(true);
    resetTimerRef.current = window.setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Button
      {...props}
      type="button"
      variant={props.variant || 'adminSecondary'}
      iconStart={copied ? 'check' : 'content_copy'}
      aria-label={copied ? copiedLabel : props['aria-label'] || children}
      onClick={handleCopy}
    >
      {copied ? copiedLabel : children}
    </Button>
  );
}
